export default [
  {
    name: 'driver-create',
    path: '/drivers/create',
    component: () => import('@/views/drivers/DriverManage')
  },
  {
    name: 'driver-edit',
    path: '/drivers/:id/edit',
    component: () => import('@/views/drivers/DriverManage')
  },
  {
    name: 'driver-view',
    path: '/drivers/:id/view',
    component: () => import('@/views/drivers/DriverManage')
  },
  {
    name: 'driver-find',
    path: '/drivers/find',
    component: () => import('@/views/drivers/DriverFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeDrivers.js